import { ConnectAppleButton } from 'react_components/connect_apple_button';
import { ConnectGoogleButton } from 'react_components/connect_google_button';
import { ContributeTrailApp } from 'react_components/contribute/contribute_trail_app';
import { Converter } from 'react_components/converter/converter';
import { ConverterSuccess } from 'react_components/converter/converter_success';
import { FullscreenMapElevationPane } from 'react_components/search/fullscreen/map_elevation_pane';
import { GiftFlow } from 'components/GiftFlow/GiftFlow/GiftFlow';
import { LifelineSearchInterface } from 'react_components/admin/lifeline_search_interface';
import { LocationMergeInterface } from 'react_components/admin/location_merge_interface';
import { MobileRoadblock } from 'react_components/branch/mobile_roadblock';
import { PhotoAdminTool } from 'react_components/admin/photo_admin_tool';
import { PhotoForTrailOrTrack } from 'react_components/photos/photo_for_trail_or_track';
import { PrintMap } from 'react_components/print/PrintMap';
import { ProfileEditForm } from 'react_components/profile_edit_form';
import { StatusUpdateResults } from 'react_components/status_update/status_update_results';
import { TrailRatingStars } from 'react_components/trail_rating_stars';
import { TranslationEditInterface } from 'react_components/admin/translation_edit_interface';
import { UserStatsDashboard } from 'react_components/stats/user_stats_dashboard';
import About from 'pages/About';
import AccountMergeInterface from 'components/admin/AccountMergeInterface';
import AcquiredContentInterface from 'components/admin/AcquiredContentInterface';
import AlgoliaSearchBox from 'components/AlgoliaSearchBox';
import AutoRenewal from 'components/AutoRenewal';
import BannerManager from 'components/admin/BannerManager';
import BulkTrailEdit from '../pages/BulkTrailEdit';
import Careers from 'pages/Careers';
import CommunityApp from '../microapps/Community/Feed';
import CouponManager from 'components/admin/CouponManager';
import CreateListPopupButton from 'components/profile/CreateListPopupButton';
import DeleteRecording from 'components/DeleteRecording';
import DoMoreWithPro from 'components/DoMoreWithPro';
import FacebookSettings from 'components/FacebookSettings';
import FooterWrapper from 'components/FooterWrapper';
import ForgotPasswordForm from 'components/forms/ForgotPasswordForm';
import GeneralPrivacyPolicy from 'components/privacyPolicy/GeneralPrivacyPolicy';
import GlobalActions from 'components/GlobalActions';
import HomePage from 'pages/HomePage';
import Lightbox from 'components/shared/Lightbox';
import ListContainer from 'components/ListContainer';
import MapStarRating from 'components/forms/MapStarRating';
import NavigationWrapper from 'components/NavigationWrapper';
import PasswordResetForm from 'components/forms/PasswordResetForm';
import PhotoForTrailOrTrackCollection from 'components/profile/PhotoForTrailOrTrackCollection';
import PhotoPopup from 'components/shared/MapPopups/PhotoPopup';
import PortalApp from '../microapps/Portal';
import PrintPage from 'components/PrintPage';
import ProfileSlidingTabs from 'components/profile/ProfileSlidingTabs';
import QuoteRotator from 'components/QuoteRotator';
import RecordingSearchInterface from 'components/admin/RecordingSearchInterface';
import RedemptionPage from 'components/RedemptionPage';
import Refer from 'components/Refer';
import ReferralRouter from 'components/ReferralRouter';
import RemoteLightbox from 'components/shared/RemoteLightbox';
import ProStatus from 'components/ProStatus';
import ReviewsUgcWrapper from 'components/trailUgc/ReviewsUgcWrapper';
import SearchApp from 'components/SearchApp';
import SidebarTrailResultListWrapper from 'components/SidebarTrailResultListWrapper';
import SocialButtonGroup from 'components/community/SocialButtonGroup';
import TrailUgcWrapper from 'components/trailUgc/TrailUgcWrapper';
import UserListItem from 'components/UserListItem';
import WeatherConditions from 'components/TrailDetails/WeatherConditions';
import MemberSearchBoxContainer from 'components/forms/MemberSearchBoxContainer';
import AvatarStackContainer from 'components/AvatarStackContainer';

require('@alltrails/maps/sharedCss.css');
require('@alltrails/shared/sharedCss.css');

const ReactRailsUJS = require('react_ujs');

const context = {
  About,
  AccountMergeInterface,
  AcquiredContentInterface,
  MemberSearchBoxContainer,
  AlgoliaSearchBox,
  AutoRenewal,
  BannerManager,
  BulkTrailEdit,
  Careers,
  CommunityApp,
  ConnectAppleButton,
  ConnectGoogleButton,
  ContributeTrailApp,
  Converter,
  ConverterSuccess,
  CouponManager,
  CreateListPopupButton,
  DeleteRecording,
  DoMoreWithPro,
  FacebookSettings,
  FooterWrapper,
  ForgotPasswordForm,
  FullscreenMapElevationPane,
  GeneralPrivacyPolicy,
  GiftFlow,
  GlobalActions,
  HomePage,
  LifelineSearchInterface,
  Lightbox,
  ListContainer,
  LocationMergeInterface,
  NavigationWrapper,
  MapStarRating,
  MobileRoadblock,
  PasswordResetForm,
  PhotoAdminTool,
  PhotoForTrailOrTrack,
  PhotoForTrailOrTrackCollection,
  PhotoPopup,
  PortalApp,
  PrintMap,
  PrintPage,
  ProfileEditForm,
  ProfileSlidingTabs,
  QuoteRotator,
  RecordingSearchInterface,
  RedemptionPage,
  Refer,
  ReferralRouter,
  RemoteLightbox,
  ProStatus,
  ReviewsUgcWrapper,
  SearchApp,
  SidebarTrailResultListWrapper,
  SocialButtonGroup,
  StatusUpdateResults,
  TrailRatingStars,
  TrailUgcWrapper,
  TranslationEditInterface,
  UserListItem,
  UserStatsDashboard,
  WeatherConditions,
  AvatarStackContainer
};

ReactRailsUJS.getConstructor = className => context[className];
